var map = {
	"./wec-icon-checkmark.svg": [
		527,
		602
	],
	"./wec-icon-chevron-left.svg": [
		318,
		224
	],
	"./wec-icon-chevron-right.svg": [
		35,
		318
	],
	"./wec-icon-close.svg": [
		560,
		100
	],
	"./wec-icon-instagram.svg": [
		410,
		869
	],
	"./wec-icon-logo--full-white.svg": [
		935,
		784
	],
	"./wec-icon-logo--white.svg": [
		604,
		93
	],
	"./wec-icon-logo.svg": [
		141,
		713
	],
	"./wec-icon-mail.svg": [
		684,
		963
	],
	"./wec-icon-nav-burger.svg": [
		858,
		659
	],
	"./wec-icon-phone.svg": [
		762,
		752
	],
	"./wec-icon-whatsapp.svg": [
		134,
		521
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = () => Object.keys(map);
webpackAsyncContext.id = 952;
module.exports = webpackAsyncContext;